module.exports = __webpack_public_path__ + "static/media/payal_sankpal.24a35d95.png";